export function formatLongNumberToString(x, maxLength = 8) {
    var _a;
    if (x >= 1) {
        return x.toFixed(2);
    }
    const [, fractional] = x.toString().split('.');
    const fractionalLength = (_a = fractional === null || fractional === void 0 ? void 0 : fractional.length) !== null && _a !== void 0 ? _a : 0;
    return fractionalLength > maxLength ? x.toFixed(maxLength) : x.toString();
}
